define("shared/components/shared/loading-spinner", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.LoadingSpinnerComponent = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--loadingWrapper {{if @additionalClass @additionalClass}}" data-test-id="loading-spinner" ...attributes>
    <div class="o--loading"></div>
  </div>
  */
  {
    "id": "1DbeP9or",
    "block": "[[[11,0],[16,0,[29,[\"o--loadingWrapper \",[52,[30,1],[30,1]]]]],[24,\"data-test-id\",\"loading-spinner\"],[17,2],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--loading\"],[12],[13],[1,\"\\n\"],[13]],[\"@additionalClass\",\"&attrs\"],false,[\"if\"]]",
    "moduleName": "shared/components/shared/loading-spinner.hbs",
    "isStrictMode": false
  });
  const LoadingSpinnerComponent = _exports.LoadingSpinnerComponent = (0, _templateOnly.default)();
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, LoadingSpinnerComponent);
});